const g2 = require('../../g2');
class TooltipWare extends g2.widget.TooltipWare {
    constructor(opts) {
        super(opts);
        //
        this.g2map = opts.map;
        this.caculator = opts.caculator;
        //
        this.tooltipSet = {};
    }

    /**
     * @method
     * @param {*} opts 
     */
    addPopup(opts) {
        let fn = this['_addPopup_' + opts.type];
        return fn.call(this, opts);
    }

    /**
     * 
     * @param {*} id 
     * @param {*} opts 
     */
    updatePopup(id, opts) {
        let popup = this.tooltipSet[id] || null;
        if(popup) {
            this.update(popup);
        }
        return popup;
    }

    /**
     * 
     * @param {*} id 
     */
    updatePosition(id) {
        let popup = this.tooltipSet[id] || null;
        if(popup) {
            if (popup.autoPanStretegy === 0) {
                this._updatePositon0(popup);
            } else {
                this.panIntoView && this.panIntoView(popup);
            }
        }
        return popup;
    }

    /**
     * 
     * @param {*} id 
     */
    removePopup(id) {
        delete this.tooltipSet[id];
        this.remove(id);
    }

    /**
     * 
     */
    clearPopup() {
        this.tooltipSet = {};
        this.clear();
    }

    _addPopup_simple(opts) {
        return new Promise((resolve, reject) => {
            let html = '<div id="' + opts.id + '"></div>';
            const autoPanMargin = opts.autoPanMargin || 10;
            const tooltip = new g2.widget.Tooltip({
                id: opts.id,
                anchor: new g2.sfs.Point({
                    x: opts.anchor[0],
                    y: opts.anchor[1]
                }),
                content: html,
                layerId: opts.layerId,
                offset: opts.offset || [0, 0],
                className: opts.className,
                // 新增tooltip参数
                autoPan: opts.autoPan || false,
                autoPanMargin,
            });
            tooltip.autoPanMargin = autoPanMargin;
            tooltip.autoPanStretegy = opts.autoPanStretegy;
            this.add(tooltip);
            this.tooltipSet[opts.id] = tooltip;
            // set zindex
            const target = this.IdContainer[tooltip.id];
            if (target) {
                target.element.style.zIndex = parseInt(opts.zIndex);
            }
            resolve({
                id: opts.id,
                containerId: opts.id,
                tooltip: tooltip,
            });
        });
    }

    // 弹框像素范围
    _updatePositon0(popup) {
        if (this.IdContainer.hasOwnProperty(popup.id)){
            const contentEl = this.caculator.contentEl(this.IdContainer[popup.id].element);
            const mapOffset= this.caculator.offsetFn(document.getElementById(this.g2map.options.targetId));
            const offsetCss = this.caculator.offsetFn(contentEl);
            offsetCss.left -=mapOffset.left;
            offsetCss.top -=mapOffset.top;
            const size = this.caculator.sizeFn(contentEl);
            const mapSize = this.g2map.getViewSize();
            // [left, top, right, bottom]
            const margin = popup.autoPanMargin || new Array(4).fill(0);
            const offsetObj = {
                left: offsetCss.left - margin[0],
                top: offsetCss.top - margin[1],
                right: mapSize[0] - (offsetCss.left + size[0] + margin[2]),
                bottom: mapSize[1] - (offsetCss.top + size[1] + margin[3]),
            };
            console.debug('offsetCss', offsetCss);
            console.debug('offsetObj', offsetObj);
            const offset = [0, 0];
            if (offsetObj.top < 0) {
                offset[1] += Math.abs(offsetObj.top);
            }
            if (offsetObj.bottom < 0) {
                offset[1] += offsetObj.bottom;
            }
            if (offsetObj.left < 0) {
                offset[0] += Math.abs(offsetObj.left);
            }
            if (offsetObj.right < 0) {
                offset[0] += offsetObj.right;
            }
            console.debug('offset', offset);
            if (!(offset[0] ===0 && offset[1] === 0)) {
                let center = this.g2map.getCenter();
                if (center instanceof g2.sfs.Point) {
                    center = [center.x, center.y];
                }
                const pixelPoint = this.g2map.getPixelFromCoordinate(center);
                pixelPoint[0] -= offset[0];
                pixelPoint[1] -= offset[1];
                console.debug('pixelPoint', pixelPoint);
                const anchor = this.g2map.getCoordinateFromPixel(pixelPoint);
                console.debug('anchor', anchor);
                this.g2map.setCenter(new g2.sfs.Point({
                    x: anchor[0],
                    y: anchor[1],
                }));
            }
        }
    }

    // 地图像素范围
    _getMapPixelExtent() {
        const extent = this.g2map.getExtent();
        const leftTop = this.g2map.getPixelFromCoordinate([extent.minx, extent.maxy]);
        const rightBottom = this.g2map.getPixelFromCoordinate([extent.maxx, extent.miny]);
        return [leftTop[0], leftTop[1], rightBottom[0], rightBottom[1]];
    }
}
module.exports = TooltipWare;